import { Component, OnInit, Input, OnDestroy, inject, DestroyRef } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { translate } from '@jsverse/transloco';
import { Constants } from 'src/app/models/constants';
import { FormUtilService } from 'src/app/services/util/form-util.service';
import { SidenavService } from 'src/app/services/util/sidenav.service';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { MatDialog } from '@angular/material/dialog';
import { ConfirmationDialogComponent } from 'src/app/components/confirmation-dialog/confirmation-dialog.component';
// import { MgmtConfigurationService } from 'src/app/services/api/mgmt-configuration.service';
import { ActivatedRoute, Router } from '@angular/router';
import { InstancesService } from 'src/app/services/api/instances.service';
import { SolutionsService } from 'src/app/services/api/solutions.service';
import { AuthService } from 'src/app/services/auth/auth.service';
import { DateTimeFormatService } from 'src/app/services/util/date-time-format.service';
import { ToastrErrorService } from 'src/app/services/util/toastr-error.service';
import { CustomToastrService } from 'src/app/services/util/toastr.service';
import { UrlService } from 'src/app/services/util/url.service';
import { BreadcrumbItem } from 'src/app/models/breadcrumb/breadcrumb-item';
import { RouterSegments } from 'src/app/models/router-segments';
import { MatTableDataSource } from '@angular/material/table';
import {animate, state, style, transition, trigger} from '@angular/animations';
import { GenericErrorComponent } from 'src/app/components/generic-error/generic-error.component';
import { DeployStatus } from 'src/app/models/deploy/deploy-status';
import { SolutionVersionsService } from 'src/app/services/util/solution-versions.service';
import { ErrorDialogComponent } from 'src/app/components/error-dialog/error-dialog.component';

@Component({
    selector: 'app-update-build',
    templateUrl: './update-build.component.html',
    styleUrls: ['./update-build.component.scss'],
    animations: [
        trigger('detailExpand', [
            state('collapsed', style({ height: '0px', minHeight: '0' })),
            state('expanded', style({ height: '*' })),
            transition('expanded <=> collapsed', animate('225ms cubic-bezier(0.4, 0.0, 0.2, 1)')),
        ]),
    ],
    standalone: false
})
export class UpdateBuildComponent   implements OnInit {
  private destroyRef = inject(DestroyRef);

  @Input() data;
  Constants = Constants;
  updateBuildForm: FormGroup;
  textbutton: string;
  index: any;
  versionData = [];
  dataselectedVersionId: any;
  dataselectedVersion: any;
  version: any;

  instanceId: string;
  breadcrumbItems: BreadcrumbItem[] = [];
  serviceName: any;
  taskInfo: any;
  tenantId: string;
  changeId: string;
  changeTaskId: string;
  solutionId: string;
  task: any;
  externalPackages: any;
  stepsArray = [1, 2, 3];
  currentStep = 1;
  selectedVersion: any;
  selectedExternalPackage: any;
  searchValue: any;
  filteredExternalPackages: any;
  expandedElement: any;
  dataSourceInner: any;
  dataSourceInnerPackages: any;
  dataSource: any;
  allExternalPackages: any;
  RouterSegments = RouterSegments;

  innerTableColumns: string[] = ['name', 'path', 'currentVersion', 'targetVersion'];
  visitedSteps = {
    stepOne: true,
    stepTwo: false,
    stepThree: false
  };

 inprogressStatus = [DeployStatus.DEPLOYING, DeployStatus.UPDATING, DeployStatus.CONFIGURING, DeployStatus.OPERATION_INPROGRESS, DeployStatus.INPROGRESS];
 errorStatus = [DeployStatus.FAILED, DeployStatus.UPDATE_FAILED, DeployStatus.CONFIGURATION_FAILED];
 terminateStatus = [DeployStatus.TERMINATED, DeployStatus.TERMINATING, DeployStatus.TERMINATION_FAILED];
 completedStatus = [DeployStatus.DEPLOYED, DeployStatus.UPDATED, DeployStatus.CONFIGURED];

  constructor(private formBuilder: FormBuilder, public sidenavService: SidenavService,
     // private configurationService: MgmtConfigurationService,
     public dialog: MatDialog,
     public dateTimeFormatService: DateTimeFormatService, private toastrService: CustomToastrService,
      public urlService: UrlService, private activatedRoute: ActivatedRoute,
      private instanceService: InstancesService, private solutionsService: SolutionsService, private router: Router,
      private authService: AuthService, private toastrErrorService: ToastrErrorService,
      public solutionVersionsService: SolutionVersionsService) {
      
     }

  ngOnInit(): void {
    this.sidenavService.tenantSelectedMenu = 'TENANT_LAYOUT.MENU.CONTINUOUS_UPDATE';
    this.tenantId = this.activatedRoute.snapshot.params.id;
    this.solutionId = this.activatedRoute.snapshot.params.solutionId;
    this.changeId = this.activatedRoute.snapshot.params.changeId;
    this.instanceId = this.activatedRoute.snapshot.params.instanceId;

    this.getInstanceDetails();
  }

  getInstanceDetails(): void {
    this.instanceService.getInstanceDetails(this.instanceId)
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe(data => {
        if (data) {
          this.data = data;
          this.solutionsService.getReferencePackages(this.solutionId, this.tenantId)
            .pipe(takeUntilDestroyed(this.destroyRef))
            .subscribe((data: any) => {
              if (data.total > 10) {
                const size = data.total
                this.solutionsService.getReferencePackages(this.solutionId, this.tenantId, size)
                  .pipe(takeUntilDestroyed(this.destroyRef))
                  .subscribe(results => {
                    var customImages: any = results.data
                    this.allExternalPackages = customImages;
                    this.externalPackages = customImages?.filter(item => item.id !== this.data?.packageReferenceId);
                    this.filteredExternalPackages = this.externalPackages;
                  });
              } else {
                this.allExternalPackages = data.data;
                this.externalPackages = data.data?.filter(item => item.id !== this.data?.packageReferenceId);
                this.filteredExternalPackages = this.externalPackages;
              }
          },
          (error) => {
        setTimeout(() => {
		      const title = translate('ERRORS.SERVICE_AVAILABILITY');
          const message = error?.message ? error?.message : (error?.error?.message ? error?.error?.message : (error?.errmsg ? error?.errmsg : translate('SERVICE.INTERNAL_SERVER_ERROR')));
          this.toastrService.errMessage(message, title);
        }, 500);
          });

        }
      },
      (error) => {
        setTimeout(() => {
		      const title = translate('ERRORS.SERVICE_AVAILABILITY');
          const message = error?.message ? error?.message : (error?.error?.message ? error?.error?.message : (error?.errmsg ? error?.errmsg : translate('SERVICE.INTERNAL_SERVER_ERROR')));
          this.toastrService.errMessage(message, title);
        }, 500);
    });
  }

  getReleaseVersions(solutionId,targetSolutionVersionId): void {
    if(targetSolutionVersionId) {
      this.solutionsService.getSolutionVersion(solutionId, targetSolutionVersionId)
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe(task => {
        this.taskInfo = task;
      },
      (error) => {
        setTimeout(() => {
		      const title = translate('ERRORS.SERVICE_AVAILABILITY');
          const message = error?.message ? error?.message : (error?.error?.message ? error?.error?.message : (error?.errmsg ? error?.errmsg : translate('SERVICE.INTERNAL_SERVER_ERROR')));
          this.toastrService.errMessage(message, title);
        }, 500);
      });
    }
  }

  goToInstances(): void {
    this.router.navigate(['/', this.authService.principal.provider, RouterSegments.TENANT, this.tenantId, RouterSegments.CONTINUOUS_UPDATE,
    this.solutionId, this.task.blueprintId, this.changeId, RouterSegments.INSTANCE]);
  }

  goToStep(currentStep, skip?): void {
    if (this.currentStep === 2) {
      this.visitedSteps.stepTwo = true;
    } else if (this.currentStep === 3) {
      this.visitedSteps.stepThree = true;
    }
    this.currentStep = currentStep;
    if (skip) {
      this.selectedExternalPackage = undefined;
    }
  }

  versionChanged(value): void {
    this.selectedVersion = value;
  }

  externalPackageChanged(value): void {
    this.selectedExternalPackage = value;
    this.expandedElement = undefined;
    this.selectedExternalPackage.references.forEach(data => data.arrowClick = false);
    if (this.data.packageReferenceId) {
      const currentPackage = this.allExternalPackages.find(item => item.id === this.data.packageReferenceId);
      this.selectedExternalPackage?.references?.forEach(component => {
        component?.images?.forEach(image => {
          currentPackage?.references?.forEach(extComp => {
            if (extComp?.images?.find(item => item?.name === image?.name)) {
              image.currentVersion = extComp?.images?.find(item => item?.name === image?.name)?.version;
            }
          })
        })
        component?.packages?.forEach(pack => {
          currentPackage?.references?.forEach(extComp => {
            if (extComp?.packages?.find(item => item?.name === pack?.name)) {
              pack.currentVersion = extComp?.packages?.find(item => item?.name === pack?.name)?.version;
            }
          })
        })
      })
    }
    this.dataSource = new MatTableDataSource(this.selectedExternalPackage?.references);
  }

  searchChanged(value): void {
    this.filteredExternalPackages = this.externalPackages.filter(item => item?.name?.toLowerCase().startsWith(value.toLowerCase()));
  }

  onClickPackage() {
    if (this.filteredExternalPackages?.length === 0) {
      this.filteredExternalPackages = this.externalPackages;
      this.searchValue = undefined;
    }
  }

  onArrowClick(data): void {
    this.expandedElement = this.expandedElement === data ? null : data;
    this.selectedExternalPackage.references.find(item => item.component === data.component).arrowClick = !this.selectedExternalPackage?.references?.find(item => item.component === data.component)?.arrowClick;
    this.selectedExternalPackage?.references?.forEach(item =>  {
      if(item.component !== data.component) {
        item.arrowClick = false;
      }
    });
    this.dataSourceInner = this.selectedExternalPackage?.references?.find(item => item.component === data.component).images;
    this.dataSourceInnerPackages = this.selectedExternalPackage?.references?.find(item => item.component === data.component).packages;
  }

  updateBuild(): void {
    if (!this.selectedVersion) {
      this.dialog.open(GenericErrorComponent, {
        minHeight: '342px',
        width: '566px',
        panelClass: 'flex-dialog'
      });
      return;
    }
    this.dialog.open(ConfirmationDialogComponent, {
      panelClass: 'default-dialog-wrapper',
      width: '566px',
      autoFocus: false,
      data: {
        title: translate('INSTANCE_DETAILS.UPDATE_BUILD.TITLE'),
        message: this.selectedExternalPackage ? translate('INSTANCE_DETAILS.UPDATE_BUILD.MESSAGE_WITH_PACKAGE') : translate('INSTANCE_DETAILS.UPDATE_BUILD.MESSAGE'),
        confirmButtonText: translate('BUTTONS.CONFIRM')
      }
    })
      .afterClosed()
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe(confirm => {
        if (confirm) {
          const versionId = this.versionData.find(item => item?.version === this.selectedVersion)?.versionId;
          const versionForm = {
            id: this.instanceId,
            targetSolutionVersionId: versionId,
            packageReferenceId: this.selectedExternalPackage.id
          };
          this.instanceService.putBuildVersion(versionForm)
            .pipe(takeUntilDestroyed(this.destroyRef))
            .subscribe(reposnse => {
              this.router.navigate(['/', this.authService.principal.provider, RouterSegments.TENANT, this.tenantId, RouterSegments.CONTINUOUS_UPDATE,
                this.solutionId, this.task.blueprintId, this.changeId, RouterSegments.INSTANCE]);
            setTimeout(() => {
              const title = translate('INSTANCE_DETAILS.UPDATE_BUILD');
              const message = translate('INSTANCE_DETAILS.UPDATE_BUILD.UPDATE_BUILD_SUCCESS');
              this.toastrService.successMessage(message, title);
            }, 500);
            },
            (error) => {
             const errorMessage = typeof error === 'string' ? error: typeof error?.error === 'string' ? error.error : error;
              this.dialog.open(ErrorDialogComponent, {
                minHeight: '342px',
                width: '630px',
                panelClass: 'flex-dialog',
                data: {
                  title: translate('ERROR_DIALOG.UPDATE_BUILD_FAILED'),
                  description: errorMessage
                 }
              });
          });
        }
      });
  }
}
